import React from 'react';
import { useTranslation } from 'react-i18next';
import { openSearchOverlay } from './SearchOverlay';
import { hasWebappSession } from './lib/lunar-user';
import { pricingV3Enabled } from './lib/feature-flags';

/** Pricing v3 (Jon + Nico, Nov 4): Discover is locked without a subscription,
 *  so public search led a signed-out visitor straight into the lock. Hidden
 *  for signed-out visitors while v3 is on. */
export function showNavSearch(): boolean {
  return !(pricingV3Enabled() && !hasWebappSession());
}

/**
 * DEV-11278: Search entry point for the marketing site navbar.
 * DEV-11294: opens the in-place SearchOverlay (mounted in Layout) instead of
 * navigating the user into the Discover app.
 */
export const NavSearchButton: React.FC = () => {
  const { t } = useTranslation();
  const [show] = React.useState(showNavSearch);
  if (!show) return null;
  return (
    <button
      onClick={openSearchOverlay}
      aria-label={t('common.search')}
      className="nav-search-btn"
      title={`${t('common.search')} ⌘K`}
    >
      <svg width="16" height="16" viewBox="0 0 256 256" fill="currentColor">
        <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" />
      </svg>
      {/* DEV-11335: expose the "Search" label when the nav has room; CSS drops
          it (then the ⌘K chip) as the desktop nav tightens, consolidating to an
          icon-only pill. */}
      <span className="nav-search-label">{t('common.search')}</span>
      <span className="nav-search-hint">⌘K</span>
    </button>
  );
};
